import { gql } from '@apollo/client';

const FIELDS = gql`
  fragment UniverseNotificationFields on UniverseNotification {
    id
    type
    title
    body
    target
    createdAt
    readAt
    project {
      id
      kind
      number
    }
    allocation {
      id
      kind
    }
    linguist {
      id
      name
    }
  }
`;

export const MY_NOTIFICATIONS = gql`
  query MyNotifications($cursor: String, $limit: Int) {
    myNotifications(cursor: $cursor, limit: $limit) {
      items {
        ...UniverseNotificationFields
      }
      nextCursor
      unreadCount
    }
  }
  ${FIELDS}
`;
export const NOTIFICATION_COUNT = gql`
  query NotificationCount {
    myNotificationsUnreadCount
  }
`;
export const NOTIFICATIONS_CHANGED = gql`
  subscription NotificationsChanged {
    myNotificationsChanged {
      kind
      unreadCount
      ids
    }
  }
`;
export const MARK_NOTIFICATIONS_READ = gql`
  mutation MarkNotificationsRead($ids: [ID!]!) {
    markMyNotificationsRead(ids: $ids) {
      kind
      unreadCount
      ids
    }
  }
`;
export const MARK_ALL_NOTIFICATIONS_READ = gql`
  mutation MarkAllNotificationsRead {
    markAllMyNotificationsRead {
      kind
      unreadCount
      ids
    }
  }
`;
export const OPEN_NOTIFICATION = gql`
  mutation OpenNotification($id: ID!) {
    openMyNotification(id: $id) {
      ok
      target
      reason
      message
      notification {
        ...UniverseNotificationFields
      }
      allocationDetails {
        id
        status
        firstName
        lastName
        sourceLanguage
        targetLanguage
        acceptedDateTime
        startDateTime
        endDateTime
        deliveryDateTime
      }
    }
  }
  ${FIELDS}
`;
export const PUSH_CONFIG = gql`
  query PushConfig {
    universePushConfig {
      enabled
      publicKey
    }
  }
`;
export const PUSH_DEVICES = gql`
  query PushDevices($currentEndpoint: String) {
    myPushDevices(currentEndpoint: $currentEndpoint) {
      id
      label
      current
      createdAt
      lastSuccessAt
    }
  }
`;
export const REGISTER_PUSH = gql`
  mutation RegisterPush($subscription: UniversePushSubscription!) {
    registerMyPushSubscription(subscription: $subscription) {
      id
      label
      current
    }
  }
`;
export const UNREGISTER_PUSH = gql`
  mutation UnregisterPush($endpoint: String!) {
    unregisterMyPushSubscription(endpoint: $endpoint)
  }
`;
export const REMOVE_PUSH_DEVICE = gql`
  mutation RemovePushDevice($id: ID!) {
    removeMyPushDevice(id: $id)
  }
`;
